import React, { Component } from "react";
import AutoInput from "../containers/AutoInput";
import { getBelongsToValue } from '../utils/models'
import withValues from "../hocs/withValues";

class containersCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showContent: false,
    };
  }

 

  render() {
    return (
      <div>
        <AutoInput
          form={this.props.form}
          model={"arrivalnotification"}
          attribute={"arrivalnotification"}
          value={getBelongsToValue("arrivalnotification", this.props.belongsTo)}
          hidden
        />
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"containerNumber"}
        />
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"seal"}
        />
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"vol"}
        />
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"weight"}
        />
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"packagesContainers"}
        />
      </div>
    );
  }
}

export default withValues(containersCreate);



// WEBPACK FOOTER //
// ./src/forms/ContainersCreate.js